'use strict';

angular.module('shiftTraderApp')
  .directive('saPhoneNumbersProfile', function () {
    return {
      templateUrl: 'views/directives/saPhoneNumbersProfile.html',
      restrict: 'A',
      scope: {
        user:'=saPhoneNumbersProfile',
        form:'=formVariable',
        me:'=loggedInUser'
      },
      controller: 'SaPhoneNumbersProfileCtrl'
    };
  });
